import React, { useEffect, useState } from 'react';
import { Box, Stack, Tab, Tabs } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import DraftDocumentListPageActions from '../components/DraftDocumentListPageActions';
import TopBar from '../../../components/TopBar';
import { useSelector } from 'react-redux';
import FeatureNotSupportedDialog from '../../common/FeatureNotSupportedDialog';
import DraftInvoiceListPage from './DraftInvoiceListPage';
import DraftCreditNoteListPage from './DraftCreditNoteListPage';
import DraftDebitNoteListPage from './DraftDebitNoteListPage';
import DraftRefundListPage from './DraftRefundListPage';

const tabs = [
  { key: 'invoices', label: 'Invoices' },
  { key: 'credit-notes', label: 'Credit Notes' },
  { key: 'debit-notes', label: 'Debit Notes' },
  { key: 'refunds', label: 'Refunds' },
];

const DraftDocumentListPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const user = useSelector((state) => state.org.org.user);
  const queryParams = new URLSearchParams(location.search);
  const initialTab = queryParams.get('tab') || 'invoices';
  const subscription = useSelector((state) => state.org.org.subscription);

  const [selectedTab, setSelectedTab] = useState(initialTab);
  useEffect(() => {
    setSelectedTab(initialTab);
  }, [initialTab]);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    navigate(`/drafts?tab=${newValue}`);
  };
  return subscription?.features?.enable_consolidation ? (
    <Stack direction="column" spacing={3}>
      <TopBar title="Staged for Consolidation"></TopBar>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Tabs value={selectedTab} onChange={handleTabChange}>
          {tabs.map((tab) => (
            <Tab key={tab.key} label={tab.label} value={tab.key} />
          ))}
        </Tabs>
        {user?.permissions?.documents === 2 && (
          <stack direction="row" spacing={1}>
            <DraftDocumentListPageActions />
          </stack>
        )}
      </Box>
      {selectedTab === 'invoices' && <DraftInvoiceListPage />}
      {selectedTab === 'credit-notes' && <DraftCreditNoteListPage />}
      {selectedTab === 'debit-notes' && <DraftDebitNoteListPage />}
      {selectedTab === 'refunds' && <DraftRefundListPage />}
    </Stack>
  ) : (
    <FeatureNotSupportedDialog
      title={'E-Invoice Consolidation'}
      description={'Upload/create receipts and automatically generate consolidated documents.'}
    />
  );
};

export default DraftDocumentListPage;
